module.exports = __webpack_public_path__ + "img/big.dc734368.jpg";